import React from 'react';
import { Button } from './Button';
import { CheckCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function SalesLetter() {
  const benefits = ['Saber exactamente cuánto dinero tienes', 'Identificar en qué se va tu quincena (sin estrés)', 'Dejar de vivir en modo emergencia', 'Tomar decisiones con intención', 'Crear un plan financiero que sí se sostiene'];
  const notList = ['No promete hacerte rica de la noche a la mañana', 'No necesitas ganar más dinero', 'No necesitas ser experta en finanzas'];
  const includes = ['50 hacks financieros reales', 'Sistema paso a paso', 'Lenguaje simple y claro', 'Acceso inmediato'];
  return <section className="w-full py-20 bg-gradient-to-br from-white via-emerald-50/30 to-cyan-50/30" data-id="element-230">
      <div className="max-w-4xl mx-auto px-6" data-id="element-231">
        <div className="space-y-12" data-id="element-232">
          {/* What is it */}
          <div className="text-center space-y-6" data-id="element-233">
            <h2 className="font-serif text-4xl lg:text-5xl text-navy-900" data-id="element-234">
              ¿Qué es Sobrevive a la Quincena?
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-235">
              Un ebook práctico y directo, creado para personas reales que viven
              de quincena en quincena y necesitan orden, claridad y control, sin
              sacrificios extremos.
            </p>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-236">
              Nada de teorías complicadas. Nada de consejos irreales. Solo lo
              que sí funciona en la vida real.
            </p>
          </div>

          {/* Benefits */}
          <div className="bg-white rounded-3xl shadow-xl p-8 lg:p-12" data-id="element-237">
            <h3 className="font-serif text-3xl text-navy-900 mb-8 text-center" data-id="element-238">
              Con este libro vas a aprender a:
            </h3>
            <div className="space-y-4" data-id="element-239">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-240">
                  <CheckCircleIcon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-1" data-id="element-241" />
                  <p className="text-lg text-gray-700" data-id="element-242">{benefit}</p>
                </div>)}
            </div>
          </div>

          {/* What it's NOT */}
          <div className="bg-navy-900 text-white rounded-3xl p-8 lg:p-12" data-id="element-243">
            <h3 className="font-serif text-3xl mb-8 text-center" data-id="element-244">
              Lo que este libro NO es
            </h3>
            <div className="space-y-4 mb-8" data-id="element-245">
              {notList.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-246">
                  <span className="text-red-400 text-2xl flex-shrink-0" data-id="element-247">
                    ❌
                  </span>
                  <p className="text-lg text-gray-200" data-id="element-248">{item}</p>
                </div>)}
            </div>
            <p className="text-xl text-center text-emerald-400 font-bold" data-id="element-249">
              Solo necesitas una guía clara, hecha para tu realidad.
            </p>
          </div>

          {/* What's included */}
          <div className="bg-gradient-to-br from-emerald-50 to-cyan-50 rounded-3xl p-8 lg:p-12" data-id="element-250">
            <h3 className="font-serif text-3xl text-navy-900 mb-6 text-center" data-id="element-251">
              ¿Qué incluye tu compra?
            </h3>

            <div className="bg-white rounded-2xl p-6 mb-6" data-id="element-252">
              <div className="flex items-start gap-4 mb-4" data-id="element-253">
                <span className="text-4xl" data-id="element-254">📘</span>
                <div data-id="element-255">
                  <h4 className="font-bold text-2xl text-navy-900 mb-2" data-id="element-256">
                    Sobrevive a la Quincena
                  </h4>
                  <p className="text-gray-600 mb-4" data-id="element-257">
                    Ebook digital en formato PDF
                  </p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-258">
                {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-259">
                    <CheckCircleIcon className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-260" />
                    <span className="text-gray-700" data-id="element-261">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 text-center" data-id="element-262">
              <p className="text-gray-600 mb-2" data-id="element-263">Precio de hoy</p>
              <p className="text-5xl font-bold text-navy-900 mb-4" data-id="element-264">
                $9.97 <span className="text-2xl text-gray-600" data-id="element-265">USD</span>
              </p>
              <div className="flex items-center justify-center gap-4 text-sm text-gray-600 mb-6" data-id="element-266">
                <span data-id="element-267">✔ Descarga instantánea</span>
                <span data-id="element-268">•</span>
                <span data-id="element-269">✔ Formato PDF</span>
                <span data-id="element-270">•</span>
                <span data-id="element-271">✔ Acceso inmediato</span>
              </div>
              <Button size="lg" className="w-full" href={CHECKOUT_URL} data-id="element-272">
                👉 Quiero dejar de sufrir cada quincena
              </Button>
              <p className="text-sm text-gray-500 mt-4" data-id="element-273">
                Compra segura • Descarga inmediata • Soporte en español
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}